var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useMemo } from 'react';
export const useWebFsNavigationErrors = (queries) => {
    _react_refresh_temp_1();
    const errors = useMemo(() => queries.map(({ error }) => error).filter((error) => error !== null), [queries]);
    const isRetrying = queries.some(({ error, isFetching }) => error !== null && isFetching);
    const retry = useCallback(() => {
        for (const { error, refetch } of queries) {
            if (error) {
                void refetch();
            }
        }
    }, [queries]);
    return { errors, isRetrying, retry };
};
_react_refresh_temp_1(useWebFsNavigationErrors, "gytfPxGncXzbTVmLxv/EhcHfPPg=");
